import { Outlet } from 'react-router-dom'
import { Suspense } from 'react'
import { LoadingSpinner } from '@/components/common/LoadingSpinner'

export function RootLayout() {
  return (
    <Suspense fallback={<LoadingSpinner fullScreen />}>
      <Outlet />
    </Suspense>
  )
}

